export class MailCheckout{
    cpf: string;
    cd_origem: string;
    rota: string;
    placa: string;
    sm: string;
    hash: string;
    tipo: number;
}